import React from 'react'
import Grid from '@material-ui/core/Grid'
import TextField from '@material-ui/core/TextField'
import { makeStyles } from '@material-ui/core/styles'
import { generateRandomKey } from 'utils'
import { useMergedState } from 'hooks'
import InputWrapper from './InputWrapper'
import InputIcon from './InputIcon'

const styles = makeStyles(() => ({
  input: {
    width: `47%`,
  },
}))

/*
  Manejo de errores
  Hay inputs que muestran mensajes abajos y otros que no
  Por lo que el prop "error" puede ser Boolean o String
*/
export default function TextInputWrapper({
  id,
  label,
  error, //Puede ser boolean o string
  isRequired = false,
  onBlur,
  onChange,
  value,
  name,
  type = `text`,
  inputType = `text`,
  autocompleteData,
  rules: { min = 0, max, required } = {},
  size = `small`,
  InputProps = {},
  disabled = false,
  placeholder = ``,
  align = `left`,
  fullWidth = false,
  xs = 12,
  md = 12,
  coin = `CPL`,
  icon = undefined,
  isValid = false,
  color = `primary`,
  ...rest
}) {
  const classes = styles()
  const [{ localValue }, setState] = useMergedState({
    localValue: {
      ...value,
    },
  })

  function numberWithPeriods(x) {
    return x.replace(/\B(?=(\d{3})+(?!\d))/g, `.`)
  }

  function handleNewValue(nextvalue, name, sendToRed = false) {
    // only number and periods as thousands separators
    const reg = /^[0-9]{1,3}(\.[0-9]{3})*$/
    const cleanValue = nextvalue.replace(/\./g, ``)
    const formatted = numberWithPeriods(cleanValue)
    const parsedValue = nextvalue === `` || reg.test(formatted) ? formatted : ``
    setState({
      localValue: {
        [coin]: {
          ...localValue[coin],
          [name]: parsedValue,
        },
      },
      ...(name === `from` && {
        disabledTo: parsedValue === ``,
      }),
    })
    if (sendToRed) {
      onBlur({
        name: id,
        value: localValue,
        id,
      })
    }
  }

  return (
    <InputWrapper
      label={`${label} (${coin})`}
      isRequired={isRequired || required}
      align={align}
      type={inputType}
      error={error}
      fullWidth={fullWidth}
      xs={xs}
      md={md}
      disabled={disabled}
      {...rest}
    >
      <Grid container alignItems="center" justify="space-between">
        <TextField
          placeholder={`Desde ${coin}`}
          id={generateRandomKey(`pricerange-from`)}
          value={localValue[coin].from}
          type="text"
          name="from"
          disabled={disabled}
          onChange={({ target: { value, name } }) => handleNewValue(value, name)}
          onBlur={({ target: { value, name } }) => handleNewValue(value, name, true)}
          min={type === `number` ? min : null}
          max={max}
          color={color}
          error={!!error}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            ...InputProps,
            ...(icon && {
              endAdornment: <InputIcon icon={icon} />,
            }),
            className: isValid ? `validInput` : ``,
          }}
          inputProps={{
            autoFocus: false,
          }}
          size={size}
          className={classes.input}
        />
        {/* <TextField
          placeholder={`Hasta ${coin}`}
          id={generateRandomKey(`pricerange-from`)}
          value={localValue[coin].to}
          type="text"
          name="to"
          disabled={disabled || disabledTo}
          onChange={({ target: { value, name } }) => handleNewValue(value, name)}
          onBlur={({ target: { value, name } }) => handleNewValue(value, name, true)}
          min={type === `number` ? min : null}
          max={max}
          color={color}
          error={!!error}
          InputLabelProps={{
            shrink: true,
          }}
          InputProps={{
            ...InputProps,
            ...(icon && {
              endAdornment: <InputIcon icon={icon} />,
            }),
            className: isValid ? `validInput` : ``,
          }}
          size={size}
          className={classes.input}
        /> */}
      </Grid>
    </InputWrapper>
  )
}
